"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardFilterReferenceObjRef = exports.isDashboardAttributeFilterReference = exports.isDashboardDateFilterReference = exports.isTempFilterContext = exports.isFilterContext = exports.isFilterContextDefinition = exports.isAllTimeDashboardDateFilter = exports.newAllTimeDashboardDateFilter = exports.newAbsoluteDashboardDateFilter = exports.newRelativeDashboardDateFilter = exports.isDashboardDateFilter = exports.isDashboardAttributeFilter = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
/* eslint-disable @typescript-eslint/no-empty-interface, import/namespace */
var m = tslib_1.__importStar(require("@gooddata/sdk-model"));
/**
 * Type-guard testing whether the provided object is an instance of {@link IDashboardAttributeFilter}.
 * @deprecated Use {@link @gooddata/sdk-model#isDashboardAttributeFilter}
 * @alpha
 */
exports.isDashboardAttributeFilter = m.isDashboardAttributeFilter;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDashboardDateFilter}.
 * @deprecated Use {@link @gooddata/sdk-model#isDashboardDateFilter}
 * @alpha
 */
exports.isDashboardDateFilter = m.isDashboardDateFilter;
/**
 * Creates a new relative dashboard date filter.
 * @param granularity - granularity of the filters (month, year, etc.)
 * @param from - start of the interval – negative numbers mean the past, zero means today, positive numbers mean the future
 * @param to - end of the interval – negative numbers mean the past, zero means today, positive numbers mean the future
 * @deprecated Use {@link @gooddata/sdk-model#newRelativeDashboardDateFilter}
 * @alpha
 */
exports.newRelativeDashboardDateFilter = m.newRelativeDashboardDateFilter;
/**
 * Creates a new absolute dashboard date filter.
 * @param from - start of the interval in ISO-8601 calendar date format
 * @param to - end of the interval in ISO-8601 calendar date format
 * @deprecated Use {@link @gooddata/sdk-model#newAbsoluteDashboardDateFilter}
 * @alpha
 */
exports.newAbsoluteDashboardDateFilter = m.newAbsoluteDashboardDateFilter;
/**
 * Creates a new all time date filter. This filter is used to indicate that there should be no filtering on the dates.
 * @deprecated Use {@link @gooddata/sdk-model#newAllTimeDashboardDateFilter}
 * @alpha
 */
exports.newAllTimeDashboardDateFilter = m.newAllTimeDashboardDateFilter;
/**
 * Type-guard testing whether the provided object is an All time dashboard date filter.
 * @deprecated Use {@link @gooddata/sdk-model#isAllTimeDashboardDateFilter}
 * @alpha
 */
exports.isAllTimeDashboardDateFilter = m.isAllTimeDashboardDateFilter;
/**
 * Type-guard testing whether the provided object is an instance of {@link IFilterContextDefinition}.
 * @deprecated Use {@link @gooddata/sdk-model#isFilterContextDefinition}
 * @alpha
 */
exports.isFilterContextDefinition = m.isFilterContextDefinition;
/**
 * Type-guard testing whether the provided object is an instance of {@link IFilterContext}.
 * @deprecated Use {@link @gooddata/sdk-model#isFilterContext}
 * @alpha
 */
exports.isFilterContext = m.isFilterContext;
/**
 * Type-guard testing whether the provided object is an instance of {@link ITempFilterContext}.
 * @deprecated Use {@link @gooddata/sdk-model#isTempFilterContext}
 * @alpha
 */
exports.isTempFilterContext = m.isTempFilterContext;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDashboardDateFilterReference}.
 * @deprecated Use {@link @gooddata/sdk-model#isDashboardDateFilterReference}
 * @alpha
 */
exports.isDashboardDateFilterReference = m.isDashboardDateFilterReference;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDashboardAttributeFilterReference}.
 * @deprecated Use {@link @gooddata/sdk-model#isDashboardAttributeFilterReference}
 * @alpha
 */
exports.isDashboardAttributeFilterReference = m.isDashboardAttributeFilterReference;
/**
 * Gets reference to object being used for filtering. For attribute filters, this will be reference to the display
 * form. For date filters this will be reference to the data set.
 * @deprecated Use {@link @gooddata/sdk-model#dashboardFilterReferenceObjRef}
 * @alpha
 */
exports.dashboardFilterReferenceObjRef = m.dashboardFilterReferenceObjRef;
//# sourceMappingURL=filterContext.js.map